<template>
  <div>
    <div class="page-title-block">
      <mtd-row class="page-head-block">
        <mtd-col :span="21" class="height-full">
          <span class="page-head-title">告警管理</span>
        </mtd-col>
        <a href="https://km.sankuai.com/collabpage/2257670643" target="_blank">
          <mtd-button :span="3" type="text" icon="mtdicon mtdicon-question-circle-o" style="float: right">
            <span>告警处理FAQ</span>
          </mtd-button>
        </a>
      </mtd-row>
      <mtd-row>
        <mtd-form :model="search_params" :label-width="100">
          <mtd-row :gutter="16">
            <mtd-col :span="6">
              <mtd-form-item prop="params" style="padding-left: 0" label="关键字:">
                <mtd-input prefix-icon="mtdicon mtdicon-search" placeholder="当事人mis/告警名称" style="width: 100%;"
                           v-model="search_params.keyword" clearable/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="appealStatus" label="告警状态:">
                <mtd-select style="width: 100%;" v-model="search_params.appealStatus" clearable>
                  <mtd-option label="全部" :value="0"/>
                  <mtd-option label="已完成" :value="1"/>
                  <mtd-option label="未完成" :value="2"/>
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="createTime" label="时间:">
                <mtd-date-picker type="datetimerange" placeholder="选择时间" style="width: 100%" value-format="timestamp"
                                 class="search_datetime_range" v-model="search_params.createTime" clearable
                                 :options="daterange_option"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="params" style="padding-right: 0" label="抄送人:">
                <mtd-input placeholder="请输入抄送人MIS" style="width: 100%;"
                           v-model="search_params.cc" clearable />
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
          <mtd-row :gutter="16">
            <mtd-col :span="6">
              <mtd-form-item prop="params" style="padding-right: 0" label="确认人:">
                <mtd-input placeholder="请输入确认人MIS" style="width: 100%;"
                           v-model="search_params.supervisor" clearable />
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item label="归属业务:" style="margin-bottom: 0">
                <mtd-cascader :data="org_path_list" v-model="search_params.attributionBusinessArray"
                              :formatter="org_format" clearable change-on-select style="width: 100%"
                              filterable remote :loading="org_searching" :remote-method="query_org_list"
                              :load-data="load_sub_org" @change="change_org_data"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="6">
              <mtd-form-item prop="principal" style="margin-bottom: 0" label="负责人:">
                <mtd-select style="width: 100%;" v-model="search_params.principal" filterable allow-create clearable>
                  <mtd-option
                    v-for="item in bp_list"
                    :key="item"
                    :label="item"
                    :value="item" />
                </mtd-select>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="2">
              <mtd-form-item :label-width="0" style="margin-bottom: 0">
                <mtd-button  :ghost="hasTimeout === 0" type="primary" @click="change_timeout">
                  {{ timeout_button_text }}</mtd-button>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="4">
              <mtd-form-item style="margin-bottom: 0;padding-right: 0">
                <div style="float: right;">
                  <mtd-button type="text" style="color: #0a70f5;" @click="reset_search_params">重置</mtd-button>
                  <mtd-button ghost type="primary" @click="init_table(true)">搜索</mtd-button>
                </div>
              </mtd-form-item>
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </mtd-row>
    </div>
    <mtd-loading :loading="table_loading">
      <mtd-row class="page-content-block">
        <mtd-row>
          <mtd-button type="text" style="color: #0a70f5;float: right" icon="mtdicon-avatar-add" :disabled="select_id_list.length === 0" @click="open_cc_modal">添加抄送人</mtd-button>
        </mtd-row>
        <mtd-row style="margin-top: 8px">
          <mtd-table :data="reminders_list"
                     :selection="table_selection"
                     @select="table_column_selected"
                     @select-all="table_column_selected"
                     @row-click="select_row">
            <mtd-table-column type="selection" width="34"/>
            <mtd-table-column prop="createTime" label="时间" width="140">
              <template slot-scope="scope">
                {{scope.row.createTime|dateTimeFormat}}
              </template>
            </mtd-table-column>
            <mtd-table-column prop="beAlertedMis" label="当事人账号" show-overflow-tooltip width="140"/>
            <mtd-table-column prop="alarmName" label="告警名称" show-overflow-tooltip>
              <template slot-scope="scope">
                {{ scope.row.alarmName||scope.row.taskName }}
              </template>
            </mtd-table-column>
            <mtd-table-column prop="description" label="告警状态" width="120">
              <template slot-scope="scope">
                <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 1">仅告警提醒</mtd-tag>
                <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 2">待本人反馈</mtd-tag>
                <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 3">待相关方确认</mtd-tag>
                <mtd-tag theme="red" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 6">待信安复核</mtd-tag>
                <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus !== 100 && scope.row.rowStatus === 9">已完成</mtd-tag>
                <mtd-tag theme="green" type="pure" style="cursor: pointer" @click.stop="show_detail(scope.row.id)" class="page-head-title-tag" v-if="scope.row.taskStatus === 100">已完成</mtd-tag>
              </template>
            </mtd-table-column>
            <mtd-table-column prop="cc" label="抄送人" show-overflow-tooltip/>
            <mtd-table-column prop="attributionBusiness" label="归属业务" width="400" show-overflow-tooltip/>
            <mtd-table-column prop="taskName" label="任务名称" show-overflow-tooltip/>
            <mtd-table-column label="操作" width="90">
              <template slot-scope="scope">
                <mtd-button type="text" size="small" @click="show_detail(scope.row.id)" style="color: #0a70f5">查看详情</mtd-button>
              </template>
            </mtd-table-column>
          </mtd-table>
          <div style="text-align: right;margin-top: 12px;">
            <mtd-pagination size="small" :total="pagination.total" :current-page="pagination.current_page"
                            :page-size="pagination.limit" show-total show-size-changer style="display: inline-block;"
                            @change="handlePaginationChange"/>
          </div>
        </mtd-row>
      </mtd-row>
    </mtd-loading>
    <mtd-modal title="添加抄送人" width="40%" v-model="cc_modal"
               @close="close_cc_modal">
      <mtd-row>
        <mtd-form ref="cc_form_ref" :label-width="80" :model="cc_form">
          <mtd-form-item label="抄送人" prop="ccList" :rules="{required: true, message: '请输入抄送人MIS'}">
            <mtd-select :filterable="true" style="width: 100%" v-model="cc_form.ccList"
                        multiple :remote="true" :remote-method="query_misid_list"
                        :loading="misid_loading" placeholder="请输入MIS号">
              <mtd-option v-for="item in user_misid_list" :key="item.mis" :label="item.name + '/' + item.mis"
                          :value="item.mis"/>
            </mtd-select>
          </mtd-form-item>
        </mtd-form>
      </mtd-row>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_cc_modal">取消</mtd-button>
        <mtd-button type="primary" @click="submit_cc_form()">确定</mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'

  export default {
    name: "index",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
    },
    data() {
      const today = new Date();
      const start_today = new Date();
      start_today.setHours(0, 0, 0, 0);
      const shortcuts = [
        {
          text: '最近一天',
          value() {
            return [start_today, today];
          },
        },
        {
          text: '最近一周',
          value() {
            const oneWeek = new Date();
            oneWeek.setTime(start_today.getTime() - 3600 * 1000 * 24 * 7);
            return [oneWeek, today];
          },
        },
        {
          text: '最近一月',
          value() {
            const oneMonth = new Date();
            oneMonth.setTime(start_today.getTime() - 3600 * 1000 * 24 * 30);
            return [oneMonth, today];
          },
        },
      ];
      return {
        reminders_list: [],
        pagination: {
          total: 125,
          current_page: 1,
          page_size: 10,
        },
        search_params: {
          riskLevel:'',
          keyword: '',
          appealStatus: 0,
          createTime: [],
          attributionBusinessArray: [],
          attributionBusiness: '',
          cc: '',
          principal: '',
          supervisor: '',
        },
        table_loading: false,
        daterange_option: {
          shortcuts
        },
        timeout_button_text: '筛选超时未反馈告警',
        hasTimeout: 0,
        org_path_list: [
          {
            value: '美团',
            label: '美团',
            children: []
          }
        ],
        org_searching: false,
        table_selection: [],
        select_id_list: [],
        cc_modal: false,
        cc_form: {
          ccList: []
        },
        user_misid_list: [],
        misid_loading: false,
        bp_list: [],
      }
    },
    mounted: function () {
      this.init_data();
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
    },
    methods: {
      ...mapActions([
        'api_list_reminders_inquiries_by_creator',
        'api_query_org_list',
        'api_query_sub_org',
        'api_add_reminders_cc',
        'api_query_org_misid_list',
        'api_query_principals',
        'api_check_task_vp'
      ]),
      async init_data() {
        await this.init_principals();
        if (this.$route.query.timeout === 'true') {
          this.hasTimeout = 1;
        } else {
          this.hasTimeout = 0;
        }
        this.init_table();
      },
      async init_table(isBtnSearch) {
        if (isBtnSearch) {
          this.pagination.current_page = 1;
        }
        this.table_selection = [];
        this.select_id_list = [];
        this.reminders_list = [];
        this.table_loading = true;
        let params = this.search_params;
        params['pageNum'] = this.pagination.current_page;
        params['limit'] = this.pagination.page_size;
        if (this.hasTimeout === 1) {
          params['timeout'] = '1';
        } else {
          params['timeout'] = '0';
        }
        await this.api_list_reminders_inquiries_by_creator(params).then(response => {
          let result = response.data;
          this.reminders_list = result.items;
          this.pagination.total = result.tn;
        }).finally(() => {
          this.table_loading = false;
        });
      },
      reset_search_params() {
        this.search_params = {
          riskLevel: '',
          keyword: '',
          appealStatus: 0,
          createTime: [],
          attributionBusinessArray: [],
          attributionBusiness: '',
          cc: '',
          principal: this.login_user.mis_id,
          supervisor: ''
        }
      },
      show_detail(id) {
        window.open('/#/alarm/' + id);
      },
      handlePaginationChange(current, size) {
        this.pagination.current_page = current;
        this.pagination.page_size = size;
        this.init_table();
      },
      change_timeout() {
        if (this.hasTimeout === 1) {
          this.hasTimeout = 0;
        } else {
          this.hasTimeout = 1;
        }
        if (this.hasTimeout === 1) {
          this.timeout_button_text = '取消筛选超时未反馈告警';
        } else {
          this.timeout_button_text = '筛选超时未反馈告警';
        }
        this.init_table();
      },
      org_format(_labels, _selectedOptions, value) {
        if (value && value instanceof Array) {
          return value.join('-');
        }
        return '';
      },
      load_sub_org(item, resolve) {
        let keyword = '公司';
        setTimeout(() => {
          if (this.search_params.attributionBusinessArray && this.search_params.attributionBusinessArray.length > 0) {
            keyword = keyword + '-' + this.search_params.attributionBusinessArray.join("-");
          }
          this.api_query_sub_org({keyword: keyword}).then(res => {
            if (res.code === 0) {
              if (res.data.length > 0) {
                resolve(res.data);
              } else {
                item.isLeaf = true;
              }
            }
          })
        }, 200)
      },
      async query_org_list(keyword) {
        if (keyword) {
          this.org_searching = true;
          this.api_query_org_list({keyword}).then((res) => {
            const orgPathList = [];
            res.data.forEach(item => {
              orgPathList.push(item.orgNamePath);
            });
            this.org_path_list = this.convert_org(orgPathList);
          }).finally(() => {
            this.org_searching = false;
          });
        }
      },
      convert_org(orgPathList) {
        const treePathList = [];
        for (const s of orgPathList) {
          if (s === "") {
            continue;
          }
          let last = "";
          let fullLast = "";
          let fullValue = "";
          const list = s.split("-");
          for (const s1 of list) {
            if (s1 === "公司") {
              continue;
            }
            if (fullLast === "") {
              fullValue = s1;
            } else {
              fullValue = fullLast + "-" + s1;
            }
            const path = {
              label: s1,
              fullValue: fullValue,
              value: s1,
              fullParent: fullLast,
              parent: last,
              children: [],
              isLeaf: false,
            };
            let isExist = false;
            for (let i = 0; i < treePathList.length; i++) {
              if (treePathList[i].fullValue === path.fullValue) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              treePathList.push(path);
            }
            last = s1;
            fullLast = fullValue;
          }
        }
        const groupMap = {};
        for (let i = 0; i < treePathList.length; i++) {
          const platform = treePathList[i];
          if (!groupMap[platform.fullParent]) {
            groupMap[platform.fullParent] = [];
          }
          groupMap[platform.fullParent].push(platform);
        }
        for (let i = 0; i < treePathList.length; i++) {
          const platform = treePathList[i];
          if (platform.children.length === 0) {
            platform.children = groupMap[platform.fullValue];
          }
        }
        const result = [];
        for (let i = 0; i < treePathList.length; i++) {
          const platform = treePathList[i];
          if (platform.parent === "") {
            result.push(platform);
          }
        }
        return result;
      },
      change_org_data(_value, selectedOptions) {
        if (selectedOptions.length === 0) {
          this.org_path_list = [
            {
              value: '美团',
              label: '美团',
              children: []
            }
          ]
        } else {
          this.search_params.attributionBusiness = this.search_params.attributionBusinessArray.join('-');
        }
      },
      table_column_selected(selection) {
        const id_list = [];
        selection.forEach(function (item) {
          id_list.push(item.id);
        });
        this.select_id_list = id_list;
      },
      select_row({row}) {
        let flag = false;
        for (let i = 0; i < this.table_selection.length; i++) {
          if (this.table_selection[i].id === row.id) {
            this.table_selection.splice(i, 1);
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.table_selection.push(row);
        }
        this.table_column_selected(this.table_selection);
      },
      query_misid_list(keyword) {
        const vm = this;
        clearTimeout(vm.remote_mis_timer);
        if (keyword) {
          vm.misid_loading = true;
          vm.remote_mis_timer = setTimeout(async () => {
            const response = await vm.api_query_org_misid_list({keyword});
            vm.user_misid_list = response.data;
            vm.misid_loading = false;
          }, 500);
        }
      },
      open_cc_modal() {
        this.cc_modal = true;
      },
      close_cc_modal() {
        this.cc_modal = false;
        this.cc_form = {
          ccList: []
        }
      },
      async submit_cc_form() {
        await new Promise((resolve, reject) => {
          this.$refs.cc_form_ref.validate((valid) => {
            if (valid) {
              const params = {
                idList: this.select_id_list,
                ccList: this.cc_form.ccList
              };
              const vm = this;
              this.api_check_task_vp({misIdList: this.cc_form.ccList}).then(res => {
                if (res.code === 0 && res.data && res.data.length > 0) {
                  this.$mtd.confirm({
                    title: this.$getText('operation_alarm_include_vp_title', '涉及高职级人群提醒'),
                    message: this.$getText('operation_alarm_include_vp_tips', {'params': res.data.join(',')}),
                    width: '430px',
                    showCancelButton: true,
                    cancelButtonText: this.$getText('operation_alarm_include_vp_btn_cancel', '取消操作'),
                    okButtonText: this.$getText('operation_alarm_include_vp_btn_confirm', '确认提交'),
                    onCancel: function () {
                      reject('rejected');
                    },
                    onOk: function () {
                      vm.api_add_reminders_cc(params).then(res => {
                        if (res.code === 0) {
                          vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_success_tips', '添加抄送人成功'));
                          vm.init_table();
                          vm.close_cc_modal();
                        } else {
                          vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_failure_tips', '添加抄送人失败'));
                        }
                        resolve();
                      }).catch(() => {
                        resolve();
                      });
                    }
                  }).catch(() => {
                    resolve();
                  })
                } else {
                  vm.api_add_reminders_cc(params).then(res => {
                    if (res.code === 0) {
                      vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_success_tips', '添加抄送人成功'));
                      vm.init_table();
                      vm.close_cc_modal();
                    } else {
                      vm.$mtd.message.success(vm.$getText('operation_alarm_cc_add_failure_tips', '添加抄送人失败'));
                    }
                    resolve();
                  }).catch(() => {
                    resolve();
                  });
                }
              })
            } else {
              resolve();
            }
          });
        })
      },
      async init_principals() {
        await this.api_query_principals().then(res =>{
          if (res.code === 0){
            this.bp_list = res.data;
            if (this.check_empty_search_params() && !this.search_params.principal) {
              this.search_params.principal = this.login_user.mis_id;
            }
          }else {
            this.$mtd.message.error("查询负责人失败");
          }
        })
      },
      check_empty_search_params() {
        return !this.search_params.keyword && !this.search_params.principal && this.search_params.createTime.length === 0
          && this.search_params.appealStatus === 0 && this.search_params.createTime.length === 0 && !this.search_params.attributionBusiness
          && !this.search_params.cc;
      },
    }
  }
</script>

<style>
  .mtd-table-cell {
    font-size: 12px;
  }
  .search-block {
    background-color: white;
    margin-bottom: 12px;
  }
  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }
</style>
